import { defineComponent as _defineComponent } from 'vue'
import logoutIcon from '~/assets/img/LogoutIcon.svg'
import hotlistIcon from '~/assets/img/FireIcon.svg'
import settingsIcon from '~/assets/img/CogIcon.svg'
import BriefcaseIcon from '~/assets/img/BriefcaseIcon.svg'
import applicantsIcon from '~/assets/img/UserGroupIcon.svg'
import UserCircleIcon from '~/assets/img/UserCircleIcon.svg'
import dashboardIcon from '~/assets/img/HomeIcon.svg'
import positionsIcon from '~/assets/img/NewspaperIcon.svg'
import profileIcon from '~/assets/img/UserIcon.svg'
import QuestionMarkCircleIcon from '~/assets/img/QuestionMarkCircleIcon.svg'
import { useDemoStore } from '~/store/demoStore'
import IconOutlineShare from '~/components/IconOutlineShare.vue'
import mixpanel from 'mixpanel-browser'


export default /*#__PURE__*/_defineComponent({
  __name: 'NavCompany',
  emits: ["unimpersonate"],
  setup(__props) {


const unimpersonateIcon = BriefcaseIcon
const exitDemoIcon = BriefcaseIcon

const demoStore = useDemoStore()
function stopDemo() {
  demoStore.stopDemo()
}

function onReferralsClicked() {
  mixpanel.track('Clicked Company Referrals Button', { Location: 'CompanyNav' })
  window.open('https://plth3cirri9.typeform.com/to/QuBiqjt0', '_blank')
}

return { __sfc: true,unimpersonateIcon, exitDemoIcon, demoStore, stopDemo, onReferralsClicked, logoutIcon, hotlistIcon, settingsIcon, applicantsIcon, UserCircleIcon, dashboardIcon, positionsIcon, profileIcon, QuestionMarkCircleIcon, IconOutlineShare }
}

})